import React, { useEffect, useMemo, useState } from "react";
import { getUNGMListCountries } from "common/services/sanctions-list.service";
import { normalize } from "common/lib/normalize";
import { FilterValueSelect } from "Components/Common/TableFilters";

type CountryFilterProps = {
  onChange: (value: any) => void;
  value: any;
};

const CountryFilter = ({ onChange, value }: CountryFilterProps) => {
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getUNGMListCountries();

        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    const uniqueOptions = new Set();
    return data
      .map((el: any) => {
        return {
          value: el?.country,
          label: el?.country,
        };
      })
      .filter((option) => {
        if (uniqueOptions.has(option.value)) {
          return false;
        } else {
          uniqueOptions.add(option.value);
          return true;
        }
      });
  }, [data]);

  return (
    <FilterValueSelect
      id="ungmCountryFilter"
      placeholder="Select Country"
      value={value}
      onChange={onChange}
      options={options}
      isLoading={loading}
    />
  );
};

export default CountryFilter;
